import type { FreshnessChip } from "@shared/site-audit-report-view";

export function Freshness({ chips }: { chips: FreshnessChip[] }) {
  if (chips.length === 0) return null;
  return (
    <ul className="flex flex-wrap gap-2">
      {chips.map((chip) => (
        <li key={chip.id}>
          <span
            className={`inline-flex max-w-full flex-wrap items-baseline gap-x-2 rounded-full border px-3 py-1 text-xs ${
              chip.tone === "problem"
                ? "border-destructive/40 text-destructive"
                : "border-border text-foreground"
            }`}
          >
            <span className="font-medium">{chip.label}</span>
            <span>{chip.statusLabel}</span>
            {chip.detail ? <span className="text-foreground/75">{chip.detail}</span> : null}
          </span>
        </li>
      ))}
    </ul>
  );
}
